import React, { Component } from 'react'
import { Button, Confirm, Grid, Icon, Message} from 'semantic-ui-react'
import './DisplayPriceConfirmation.less'
import { acceptConfirmationPrice, addNewPaymentMethod } from '../../services/Seller';
import { withRouter } from 'react-router';
import { formatPhone } from '../../helpers/parsePhone';
import { loadStripe } from '@stripe/stripe-js';
import Config from 'Config'
import ChangePaymentMethodModal from '../ChangePaymentMethod/ChangePaymentMethod';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import errorConstants from '../../constants/errors';
import { getPaymentIntentForValidation } from '../../services/stripe';

const initialState = {
    showConfirmationDialog: false,
    confirmationMessage: '',
    confirmStatus: '',
    disableButtons: false,
    loading: false,
    showPaymentError: false,
    showGeneralError: false,
    isAccepted: false,
    buyerInfo: {},
    towingServicesName:["Car Towing Service", "Heavy Duty Towing", "Vehicle Towing Service"],
    showPaymentClearModal: false,
    stripe: {},
    paymentMethods: [],
    selectedPaymentMethod: {},
    cardFormVisibility: true,
    card: undefined,
    error: '',
    failedPayments: [],
    isDefaultCard: true
};

class DisplayPriceConfirmation extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
    }

    componentDidMount(){
        if(this.props.sbr.isAccepted){
            this.setState({isAccepted: true,
            buyerInfo: {first: this.props.buyer.buyerName, cellPhone: this.props.buyer.cellPhone}})
        }
    }

    onAccept = async () => {
        this.setState({disableButtons: true});
        

        await this.acceptRequest();
        
        //this.props.history.push('/accepted-bids');
    }

    acceptRequest = async () => {
        const res = await acceptConfirmationPrice(this.props.token, this.props.sbr.singleBuyerRequestID)
        
        if(res.resStatus == 200){
            
            if(res.data.error){
            
                if(res.data.code == errorConstants.ERROR_COMMISSION_PMT_FAILED.code){
                    //this.setState({showPaymentError: true, showGeneralError: false, loading: false});
                    if(_.isEmpty(this.state.stripe)){
                        await this.loadPaymentDetails();
                    }
                    else{
                        this.setState({showPaymentClearModal: true, 
                        error:`Unable to confirm. We need an updated payment method.`})
                    }
                }
                else{
                    this.setState({showPaymentError: false, showGeneralError: true, loading: false});
                }
                
            }
            else{
                //this.props.history.push('/accepted-bids');
                const buyer = res.data.buyer;
                this.setState({buyerInfo: buyer, isAccepted: true, showPaymentClearModal: false});
            }
        }
        else{
            this.setState({showPaymentError: false, showGeneralError: true, loading: false});
        }
    }

    loadPaymentDetails = async () => {
        const stripeRes = await loadStripe(Config.stripe.key);
        this.setState({ stripe: stripeRes});

        this.setState({
            paymentMethods: [],
            selectedPaymentMethod: {},
            cardFormVisibility: true
        }, () =>{
            this.setState({showPaymentClearModal: true,
                error:`Unable to confirm. We need an updated payment method.`})
        });
    }

    onConfirmation = () => {
        if(this.state.confirmStatus == 'decline'){
            this.setState({disableButtons: true, showConfirmationDialog: false})
            
            //this.props.history.push('/')
        }
        else{

        }
    }

    onReject = () => {
        this.setState({
            showConfirmationDialog: true,
            confirmationMessage: "Are you sure you do not want to do this tow?",
            confirmStatus: 'decline'
        })
    }

    onCloseConfirmation = () => {
        this.setState({showConfirmationDialog: false});
    }

    onCardFormToggle = (e, value) => {
        e.preventDefault();
        this.setState({
            error: '',
            cardFormVisibility: value
        })
    }

    showLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        this.setState({ loading: true });
    }

    hideLoader = () => {
        document.body.style.overflowY = 'unset'
        this.setState({ loading: false });
    }

    processPaymentChange = async () => {
        try {
            const { selectedPaymentMethod, card, cardFormVisibility, stripe } = this.state;

            let paymentMethod = selectedPaymentMethod;
            this.showLoader();
            if (cardFormVisibility) {
                if (!card) {
                    this.setState({ error: 'Invalid card details.' })
                    return;
                }
                // payment method creation
                const paymentMethodRes = await stripe.createPaymentMethod({
                    type: 'card',
                    card
                });
                if (paymentMethodRes.error) {
                    
                    this.setState({ error: paymentMethodRes.error.message })
                    return;
                }
                paymentMethod = paymentMethodRes.paymentMethod;

                const paymentRes = await getPaymentIntentForValidation(0, 0.5)
                const paymentConfirmation = await stripe.confirmCardPayment(paymentRes.data.client_secret, {
                    payment_method: paymentMethodRes.paymentMethod.id,
                    setup_future_usage: 'off_session'
                });
                if (paymentConfirmation.error) {
                    this.setState({ error: paymentConfirmation.error.message })
                    return;
                }

                const res = await addNewPaymentMethod({
                    ssPaymentMethodID: paymentMethodRes.paymentMethod.id,
                    paymentIntentID: paymentRes.data.id
                })

                //console.log(paymentMethod);
                await this.acceptRequest();
            }
        }
        catch (err) {
            //console.log(err);
            //paymentError = err;

        } finally {
            this.hideLoader();
        }


    }

    onChangePaymentModalClose = () => {
        let disableButtons = this.state.disableButtons;
        if(!this.state.isAccepted){
            disableButtons = false;
        }
        this.setState({
            showPaymentClearModal: false,
            disableButtons: disableButtons,
            error: ''
        })
    }

    render() {
        return (           
                <div className="display-price-confirmation-container">
                    <Grid>
                        <Grid.Row>
                            {
                                this.props.sbr.confirmedPrice && 
                                <Grid.Column computer={this.state.isAccepted ?  16 : 5} tablet={this.state.isAccepted ? 16 : 8} mobile={16}>
                                <div className='price-container'>
                                    Price: <span className='amount'>${this.props.sbr.confirmedPrice}</span> 
                                </div>
                                </Grid.Column>
                            }
                            
                            {!this.state.isAccepted && <Grid.Column computer={this.props.sbr.confirmedPrice ? 11 : 16} tablet={this.props.sbr.confirmedPrice ? 8 : 16} mobile={16}>
                            <div className={`button-container ${this.props.sbr.confirmedPrice ? "" : "centre"}`}>
                                <div className='accept-tow-button'>
                                    <Button disabled={this.state.disableButtons} /*loading={this.state.loading}*/ className='' onClick={this.onAccept}>{this.props.service &&  this.state.towingServicesName.findIndex((name) => {return name == this.props.service.name}) == -1 ?  "ACCEPT" : "ACCEPT TOW"}</Button>
                                </div>
                                {/*<div className='decline-tow-button'>
                                    <Button disabled={this.state.disableButtons} /*loading={this.state.loading} className='' onClick={this.onReject}>DECLINE TOW</Button>
        </div>*/}
                            </div>
                            </Grid.Column>}
                        </Grid.Row>
                        {!this.state.isAccepted && <Grid.Row>
                            <Grid.Column width={16} className="consent">
                                {
                                    this.props.sbr.confirmedPrice ? <div>After hitting accept, we will send you customer details (Name/Phone) and they will be sent your details (Name/Phone) as well.</div> :
                                    <div>After hitting accept, you’ll see the customer’s phone number. Call them to give them pricing/scheduling details</div> 
                                }
                            </Grid.Column>
                        </Grid.Row>}
                        {this.state.isAccepted &&  <><Grid.Row>
                        <Grid.Column width={16}>
                            <div className='buyer-name-container'>
                                <div className={"icon-container"}>
                                <a href={`tel:${this.state.buyerInfo.cellPhone}`}><svg xmlns="http://www.w3.org/2000/svg" width="13.453" height="13.355" viewBox="0 0 13.453 13.355">
                                        <defs>
                                            <clipPath id="clip-path">
                                                <rect id="Rectangle_8721" data-name="Rectangle 8721" width="13.453" height="13.355" fill="#377dff" />
                                            </clipPath>
                                        </defs>
                                        <g id="Group_15588" data-name="Group 15588" transform="translate(0 0)">
                                            <g id="Group_15588-2" data-name="Group 15588" transform="translate(0 0)" clipPath="url(#clip-path)">
                                                <path id="Path_41833" data-name="Path 41833" d="M3.072.1q.589.586,1.174,1.176l.694.7a.518.518,0,0,1,0,.8c-.424.417-.851.832-1.272,1.254a.3.3,0,0,0-.076.186,4.1,4.1,0,0,0,.419,1.841A6.3,6.3,0,0,0,7.926,9.576a3.449,3.449,0,0,0,1.2.187.313.313,0,0,0,.227-.1c.41-.416.824-.828,1.236-1.241a.517.517,0,0,1,.811-.005q.932.93,1.862,1.863a.517.517,0,0,1,.075.731A8.674,8.674,0,0,1,12,12.67a2.215,2.215,0,0,1-.978.606,5.532,5.532,0,0,1-.66.079,6.589,6.589,0,0,1-2.372-.566A12.6,12.6,0,0,1,5.04,10.977a16.6,16.6,0,0,1-3.4-3.662A10.135,10.135,0,0,1,.23,4.417,7.188,7.188,0,0,1,.012,3.165,2.179,2.179,0,0,1,.726,1.309,9.81,9.81,0,0,1,2.407,0" transform="translate(0)" fill="#377dff" />
                                            </g>
                                        </g>
                                    </svg></a>
                                </div>
                                <div className={"number-container"}>
                                    <a href={`tel:${this.state.buyerInfo.cellPhone}`}>{"Customer Info:"} &nbsp; <span> {this.state.buyerInfo.first} </span>  &nbsp;  <span> {this.state.buyerInfo.cellPhone ? formatPhone(this.state.buyerInfo.cellPhone) : ""} </span></a>
                                </div>

                            </div>
                        </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                        <Grid.Column width={16} className="consent" style={{fontSize: '12px', fontWeight: 'bold'}}>
                        <div>Please call the customer ASAP to schedule.</div>
                    
                    </Grid.Column>
                </Grid.Row></>}
                        {/*<Grid.Row>
                            <Grid.Column width={16} className="consent">
                                <div>By tapping the Accept Tow button you agree that youll be charged the booking fee based on your subscripiton.</div>
                            
                            </Grid.Column>
        </Grid.Row>*/}
                        {(this.state.showGeneralError || this.state.showPaymentError) && <Grid.Row>
                            <Grid.Column width={16}>
                                <Message error icon>
                                <Icon name="exclamation circle" /> 
                                    {this.state.showPaymentError && <Message.Content>
                                    Unable to confirm. Your payment method for booking fee is not valid.
Make sure the card is un locked and has enough funds for us to charge the booking fee
                                    </Message.Content>
    }
    {this.state.showGeneralError && <Message.Content>
        Unable to confirm.  Please refresh this page
                                    </Message.Content>
    }
                                </Message>
                            </Grid.Column>
                        </Grid.Row>
    }
                    </Grid>

                    <Confirm className='confirmation-dialog'
                    header='Confirm'
          open={this.state.showConfirmationDialog}
          content={this.state.confirmationMessage}
          onCancel={this.onCloseConfirmation}
          onConfirm={this.onConfirmation}
        />


{!_.isEmpty(this.state.stripe) ? <Elements stripe={this.state.stripe}>
                    <ElementsConsumer>
                        {({ stripe, elements }) => <> 
                            <ChangePaymentMethodModal
                                open={this.state.showPaymentClearModal}
                                onClose={this.onChangePaymentModalClose}
                                processPaymentChange={this.processPaymentChange}
                                stripe={stripe}
                                elements={elements}
                                onCardFormToggle={this.onCardFormToggle}
                                paymentMethods={this.state.paymentMethods}
                                setSelectedPaymentMethod={selectedPaymentMethod => this.setState({ selectedPaymentMethod })}
                                error={this.state.error}
                                isCardFormVisible={this.state.cardFormVisibility}
                                selectedPaymentMethod={this.state.selectedPaymentMethod}
                                setCard={card => this.setState({ card }, () => console.log(card))}
                                isDefaultCard={this.state.isDefaultCard}
                                setIsDefaultCard={(value) => this.setState({isDefaultCard: value}) }
                                loading={this.state.loading}
                            />
                        </>
                        }
                    </ElementsConsumer>
                </Elements> : ''
                }

        
                </div>
            
        )
    }
}

    export default withRouter(DisplayPriceConfirmation)
